import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TimeLapsComponent} from './time-laps/time-laps.component';
import {TimeLap} from './models/time_lap';
import {NgFor, NgIf} from '@angular/common';

@Component({
    selector: 'app-horizental-timeline',
    templateUrl: './horizental-timeline.component.html',
    styleUrls: ['./horizental-timeline.component.css']
})
export class HorizentalTimelineComponent implements OnInit, OnChanges {
    expectedPercentArray: any[]=[5.55,11.11,16.7,22.22,27.8,33.3,38.9,44.4,50,55.5,61.1,66.7,72.2,77.8,83.3,88.9,94.4,100];
    constructor() {}
    ngOnChanges(changes: SimpleChanges): void {
        this.allInjazpercent= changes.allInjazpercent.currentValue
        this.timeLaps = Array.from(new Array(this.labsNumber))
        .map((x, i) => {
            // console.log(x);
            let m = this.getFutureDateByMonths(i);
            console.log(m)
            return {
                name: `${Math.abs(i+1)}th m`,
                value: this.expectedPercentArray[i],
                extraValue: this.allInjazpercent,
                isCurrentTime:
                    new Date().getMonth() === m.getMonth() &&
                    new Date().getFullYear() === m.getFullYear()
            };
        })
        // .reverse();
        // throw new Error('Method not implemented.');
    }
    @Input() upperLable: string = 'نسبة الإنجاز حسب الجدول الزمني';
    @Input() lowerLable: string = 'نسبة الإنجاز الفعلية';
    @Input() labsNumber: number = 18;
    @Input() allInjazpercent: number = 0;
    @Input() endDate: Date = this.getDefaultStartDate();
    @Input() timeLaps: TimeLap[] = Array.from(new Array(this.labsNumber))
        .map((x, i) => {
            let m = this.getFutureDateByMonths(i);
            return {
                name: `${Math.abs(i+1)}th m`,
                value: this.expectedPercentArray[i],
                extraValue: this.allInjazpercent,
                isCurrentTime:
                    new Date().getMonth() === m.getMonth() &&
                    new Date().getFullYear() === m.getFullYear()
            };
        })
        // .reverse();

    getDefaultStartDate() {
        let m = new Date(2024,4,1);
        // m.setMonth(new Date().getMonth() + 6);
        return m;
    }

    getFutureDateByMonths(i: number) {
        let m = this.getDefaultStartDate();//new Date();
        m.setMonth(this.getDefaultStartDate().getMonth() + i);
        return m;
    }
    ngOnInit() {
    }
}
